"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradeType = void 0;
var TradeType;
(function (TradeType) {
    TradeType[TradeType["EXACT_INPUT"] = 0] = "EXACT_INPUT";
    TradeType[TradeType["EXACT_OUTPUT"] = 1] = "EXACT_OUTPUT";
})(TradeType || (exports.TradeType = TradeType = {}));
